// The viewer's aliases for people in a room — StationChat's `aliases` setting, from
// the room's /api/stations/<id>/my-settings. Only this viewer sees them; messages keep
// the real name and the page swaps in the alias when it shows one.

const EMPTY = { byAccount: {}, byName: {} };

// {byAccount, byName} from a my-settings body. `byName` covers messages and typing
// signals that carry no account id; the server leaves out names two people share.
export function aliasesFrom(body) {
  const out = { byAccount: {}, byName: {} };
  for (const set of (body && body.sets) || []) {
    const decl = (set.settings || []).find((s) => s.key === 'aliases' && s.type === 'map');
    if (!decl) continue;
    Object.assign(out.byAccount, (set.values && set.values.aliases) || {});
    Object.assign(out.byName, (set.names && set.names.aliases) || {});
  }
  return out;
}

// The name to show for a sender: the alias for their account. Only a message with no
// account falls back to its name, since names aren't unique and can change.
export function shownName(aliases, name, account) {
  const a = aliases || EMPTY;
  if (account != null) return a.byAccount[String(account)] || name;
  return (name && a.byName[name]) || name;
}
